var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as $ from 'jquery';
import 'select2';
const filters = document.querySelectorAll('#filtering_and_sorting .control-tl-select2');
const form = document.getElementById('filtering_and_sorting');
const timelineLoadMoreButton = document.getElementById('timeline-load-more');
const vtimelineWrapper = document.querySelector('.vtimeline-wrapper');
let stopLoad = false;
const perPageElem = document.getElementById('page_counter');
const dateStartElem = document.getElementById('date_start');
const termIdElem = document.getElementById('term_id');
const statusElem = document.getElementById('status');
const selectedNav = document.getElementById('selected-navigator');
const timelineLoadMore = true;
let loadDataFlag = false;
const vtimelineContainer = document.querySelectorAll('.vtimeline-container');
function formatOption(option) {
    var _a;
    if (!option.id) {
        return option.text;
    }
    const imageUrl = (_a = option.element.dataset) === null || _a === void 0 ? void 0 : _a.iconUrl;
    let optionWithImage;
    if (imageUrl) {
        optionWithImage = $('<span class="vtimeline-option-item"><img src="' +
            imageUrl +
            '" class="img-flag" />' +
            option.text +
            '</span>');
    }
    else {
        optionWithImage = $(`<span>${option.text}</span>`);
    }
    return optionWithImage;
}
$(document).ready(function () {
    updateSelectedTags();
    $(filters)
        .select2({
        templateResult: formatOption,
        templateSelection: formatOption,
        closeOnSelect: false,
        tags: false,
        minimumResultsForSearch: Infinity,
    })
        .on('change', (event) => {
        onChangeFilter(event.target);
        updateSelectPlaceholder();
        updateSelectedTags();
        setupTagRemovalHandler();
    });
    $('#navigator_id').on('change', (event) => {
        onChangeFilter(event.target);
        updateSelectPlaceholder();
        updateSelectedTags();
        setupTagRemovalHandler();
    });
});
$('.navigator-filter-block__item').click((event) => {
    const $item = $(event.currentTarget);
    const value = $item.data('value');
    if ($item.hasClass('inactive')) {
        $(`#navigator_id option[value="${value}"]`).prop('selected', true);
        $(`#term_id option[value="${value}"]`).prop('selected', true);
    }
    else {
        $(`#navigator_id option[value="${value}"]`).prop('selected', false);
        $(`#term_id option[value="${value}"]`).prop('selected', false);
    }
    $('#navigator_id').trigger('change');
});
function updateSelectPlaceholder() {
    $('.control-tl-select-multiple').each(function () {
        const count = $(this)
            .siblings('.select2-container')
            .find('.select2-selection__rendered')
            .children().length;
        const placeholder = $(this).data('placeholder');
        if (count > 0) {
            $(this)
                .siblings('.select2-container')
                .find('.select2-search__field')
                .attr('placeholder', `${count} обрано`);
        }
        else {
            $(this).siblings('.select2-container').find('.select2-search__field').attr('placeholder', placeholder);
        }
    });
}
function updateSelectedTags() {
    let selectedTagsHtml = '';
    let selectedCount = 0;
    const selectedNavigatorCount = $('#navigator_id').find('option:selected').length;
    const navigatorCount = $('#navigator_id').find('option').length;
    if (navigatorCount !== selectedNavigatorCount) {
        selectedTagsHtml += `<span class="selected-tag selected-navigators"><span class="color-secondary">Навігатори: </span>${selectedNavigatorCount} обрано</span>`;
    }
    $('.control-tl-select-trigger').each(function () {
        const selectedTagsArray = [];
        $(this).find('option:selected').each(function () {
            var _a;
            const imageUrl = (_a = this.dataset) === null || _a === void 0 ? void 0 : _a.iconUrl;
            const value = '';
            if (value !== this.value) {
                const optionWithImage = imageUrl ? `<span class="vtimeline-option-item"><img src="${imageUrl}" class="img-flag" />${$(this).text()}</span>` : `<span>${$(this).text()}</span>`;
                selectedTagsArray.push(optionWithImage);
            }
        });
        selectedCount += selectedTagsArray.length;
        selectedTagsArray.forEach(function (tag) {
            selectedTagsHtml += `<span class="selected-tag">${tag}</span>`;
        });
    });
    $('#selected-tags').html(`${selectedTagsHtml}`);
    $('#selected-tags').on('click', '.selected-tag', function () {
        const tagText = $(this).text();
        $(this).remove();
        $('.control-tl-select-single option, .control-tl-select-multiple option').each(function () {
            if ($(this).text() === tagText) {
                $(this).prop('selected', false);
                const id = $(this).closest('.control-tl-select-single, .control-tl-select-multiple').attr('id');
                const item = document.getElementById(id);
                onChangeFilter(item);
            }
        });
        $('.select2-selection__rendered').find(`li[title="${tagText}"]`).remove();
        updateSelectedTagsCount();
        updateSelectPlaceholder();
    });
    updateSelectedTagsCount();
}
function setupTagRemovalHandler() {
    $('.control-tl-select-trigger')
        .siblings('.select2-container')
        .find('.select2-selection__choice')
        .on('click', function () {
        const tagToRemove = $(this).attr('title') || '';
        $(this).remove();
        $('#selected-tags')
            .find('.selected-tag')
            .each(function () {
            if ($(this).text() === tagToRemove) {
                $(this).remove();
            }
        });
    });
}
function clearSelectedTags() {
    $('#selected-tags .selected-tag').each(function () {
        $(this).trigger('click');
        if ($(this).hasClass('selected-navigators')) {
            $('.navigator-filter-block__item.inactive').trigger('click');
        }
    });
}
$('.filter-wrapper-selected .clear').on('click', function () {
    clearSelectedTags();
});
function updateSelectedTagsCount() {
    var selectedTagsCount = $('#selected-tags').children().length;
    if (selectedTagsCount > 0) {
        $('.btn-filter .count').text(selectedTagsCount);
    }
    else {
        $('.btn-filter .count').text('');
    }
}
function toggleFilterWrapperVisibility() {
    const selectedTagsElement = document.getElementById('selected-tags');
    const filterWrapperSelectedElement = document.querySelector('.filter-wrapper-selected');
    if (selectedTagsElement && filterWrapperSelectedElement) {
        if (selectedTagsElement.children.length > 0) {
            filterWrapperSelectedElement.style.display = 'flex';
        }
        else {
            filterWrapperSelectedElement.style.display = 'none';
        }
    }
}
function handleSelectedTagsChange(mutationsList) {
    toggleFilterWrapperVisibility();
}
function setupSelectedTagsObserver() {
    const selectedTagsObserver = new MutationObserver(handleSelectedTagsChange);
    const selectedTagsElement = document.getElementById('selected-tags');
    if (selectedTagsElement) {
        const observerConfig = { attributes: true, childList: true, subtree: true };
        selectedTagsObserver.observe(selectedTagsElement, observerConfig);
    }
}
window.addEventListener('load', setupSelectedTagsObserver);
window.addEventListener('load', toggleFilterWrapperVisibility);
function openTimelineContent() {
    const content = document.querySelector('.js-block-scrolled');
    if (content) {
        content.classList.remove('hidden');
        initCloseTimeline();
    }
}
const loadEntityDetailsInfo = (postId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = var_from_php.ajax_url;
    const formData = new FormData();
    formData.append('action', 'timeline_details_info');
    formData.append('id', postId);
    const response = yield fetch(url, {
        method: 'POST',
        body: formData,
    });
    if (response && response.ok) {
        const respJson = yield response.json();
        const { data } = respJson;
        return data;
    }
    return false;
});
const scrollContent = () => {
    if (window.innerWidth > 991) {
        const blockScrolled = document.querySelector('.js-block-scrolled');
        if (blockScrolled instanceof HTMLElement) {
            window.addEventListener('scroll', function () {
                requestAnimationFrame(updateStyles);
            });
            function updateStyles() {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const timelineItems = document.querySelectorAll('.js-item-timeline');
                let activeItem = false;
                let nextItem = false;
                let afterActive = false;
                timelineItems.forEach((item, index) => {
                    if (afterActive) {
                        if (timelineItems[index].classList.contains('type-card-1')) {
                            nextItem = timelineItems[index];
                            afterActive = false;
                        }
                    }
                    if (item.classList.contains('active')) {
                        activeItem = item;
                        afterActive = true;
                    }
                });
                if (!nextItem && activeItem) {
                    activeItem = timelineItems[0];
                    const lastEmptyElement = document.querySelector('.js-last-element');
                    nextItem = lastEmptyElement;
                }
                if (activeItem instanceof HTMLElement && nextItem instanceof HTMLElement) {
                    const activeItemTop = activeItem ? activeItem.getBoundingClientRect().top : 0;
                    const activeItemBottom = activeItem ? activeItem.getBoundingClientRect().bottom : 0;
                    const nextItemTop = nextItem ? nextItem.getBoundingClientRect().top : 0;
                    const nextItemBottom = nextItem ? nextItem.getBoundingClientRect().bottom : 0;
                    if (scrollTop > nextItemBottom) {
                        blockScrolled.style.top = `${nextItemTop - blockScrolled.offsetHeight}px`;
                    }
                    else if (scrollTop > activeItemTop) {
                        blockScrolled.style.top = '90px';
                    }
                }
            }
        }
    }
};
scrollContent();
const cardChange = () => {
    const triggers = document.querySelectorAll('.js-item-timeline');
    const contentWrap = document.querySelector('.js-scroll-container');
    triggers &&
        triggers.forEach((item) => {
            item.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
                event.preventDefault();
                event.stopPropagation();
                let container = event.target;
                if (!container.classList.contains('js-item-timeline')) {
                    container = container.closest('.js-item-timeline');
                }
                if (!container)
                    return false;
                const activeOld = document.querySelector('.js-item-timeline.active');
                const { postId } = container.dataset;
                if (postId && contentWrap) {
                    const detailInfo = yield loadEntityDetailsInfo(postId);
                    contentWrap.innerHTML = detailInfo;
                }
                if (activeOld) {
                    activeOld.classList.remove('active');
                    const colorChange = activeOld.querySelectorAll('.js-color-change');
                    colorChange &&
                        colorChange.forEach((figure) => {
                            if (figure instanceof HTMLElement) {
                                figure.style.removeProperty('background-color');
                                figure.style.removeProperty('border-left-color');
                            }
                        });
                }
                container.classList.add('active');
                if (window.innerWidth > 991) {
                    const activeItemTop = container ? container.getBoundingClientRect().top : 0;
                    const contentContainer = document.querySelector('.js-block-scrolled');
                    if (contentContainer instanceof HTMLElement) {
                        contentContainer.style.top = `90px`;
                    }
                }
                const colorChangeNew = container.querySelectorAll('.js-color-change');
                colorChangeNew &&
                    colorChangeNew.forEach((figure) => {
                        if (figure instanceof HTMLElement) {
                            let color = container.getAttribute('data-hover-color');
                            if (!color) {
                                color = '#FB655A';
                            }
                            figure.style.backgroundColor = color;
                            figure.style.borderLeftColor = color;
                        }
                    });
                openTimelineContent();
            }));
        });
};
function initCloseTimeline() {
    const btnsClose = document.querySelectorAll('.js-trigger-timeline-content');
    btnsClose &&
        btnsClose.forEach((item) => {
            item.addEventListener('click', (event) => {
                const { target } = event;
                const container = document.querySelector('.js-block-scrolled');
                if (container) {
                    container.remove();
                }
            });
        });
}
const addPreloader = () => {
    vtimelineContainer.forEach((vtimelineWrapper) => {
        const preloader = document.createElement('div');
        preloader.classList.add('preloader');
        vtimelineWrapper.appendChild(preloader);
    });
};
const removePreloader = () => {
    vtimelineContainer.forEach((vtimelineWrapper) => {
        const preloader = vtimelineWrapper.querySelector('.preloader');
        if (preloader) {
            vtimelineWrapper.removeChild(preloader);
        }
    });
};
const addQueryParamsToUrl = (formData) => __awaiter(void 0, void 0, void 0, function* () {
    const navigators = formData.getAll('term_id[]');
    const spheres = formData.getAll('spheres_id[]');
    const levels = formData.getAll('severity_level');
    const order = formData.getAll('order');
    let navigatorsQueryParamValue;
    let spheresQueryParamValue;
    let levelsQueryParamValue;
    let orderQueryParamValue;
    let flagUpdateQueryUrl = false;
    const url = yield new URL(window.location.href);
    if (Array.isArray(navigators) && navigators.length > 0) {
        navigatorsQueryParamValue = navigators.join(',');
        url.searchParams.set('n', navigatorsQueryParamValue);
        flagUpdateQueryUrl = true;
    }
    else {
        url.searchParams.delete('n');
    }
    if (Array.isArray(spheres) && spheres.length > 0) {
        spheresQueryParamValue = spheres.join(',');
        url.searchParams.set('s', spheresQueryParamValue);
        flagUpdateQueryUrl = true;
    }
    else {
        url.searchParams.delete('s');
    }
    if (levels && levels > 0) {
        levelsQueryParamValue = levels.join(',');
        url.searchParams.set('l', levelsQueryParamValue);
        flagUpdateQueryUrl = true;
    }
    else {
        url.searchParams.delete('l');
    }
    if (order) {
        orderQueryParamValue = order;
        url.searchParams.set('order', orderQueryParamValue);
        flagUpdateQueryUrl = true;
    }
    if (flagUpdateQueryUrl) {
        window.history.pushState({ path: url.href }, '', url.href);
    }
});
const loadData = (loadMore) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    if (stopLoad) {
        return;
    }
    const url = var_from_php.ajax_url;
    const timelineWrapper = document.getElementById('timeline-wrapper');
    const btnLoadMore = document.querySelector('#timeline-load-more');
    const perPage = (_a = timelineWrapper === null || timelineWrapper === void 0 ? void 0 : timelineWrapper.dataset) === null || _a === void 0 ? void 0 : _a.per_page;
    const dateStart = (_b = timelineWrapper === null || timelineWrapper === void 0 ? void 0 : timelineWrapper.dataset) === null || _b === void 0 ? void 0 : _b.date_start;
    const dateEnd = (_c = timelineWrapper === null || timelineWrapper === void 0 ? void 0 : timelineWrapper.dataset) === null || _c === void 0 ? void 0 : _c.date_end;
    const order = (_d = timelineWrapper === null || timelineWrapper === void 0 ? void 0 : timelineWrapper.dataset) === null || _d === void 0 ? void 0 : _d.order;
    if (form instanceof HTMLFormElement) {
        const formData = new FormData(form);
        console.log('FormData: ', formData);
        yield addQueryParamsToUrl(formData);
        formData.append('action', 'timeline_load_more');
        formData.append('load_more', loadMore ? '1' : '0');
        addPreloader();
        const response = yield fetch(url, {
            method: 'POST',
            body: formData,
        });
        removePreloader();
        if (response && response.ok) {
            const respJson = yield response.json();
            const { data, success } = respJson;
            perPageElem === null || perPageElem === void 0 ? void 0 : perPageElem.setAttribute('value', data === null || data === void 0 ? void 0 : data.page);
            dateStartElem === null || dateStartElem === void 0 ? void 0 : dateStartElem.setAttribute('value', data === null || data === void 0 ? void 0 : data.date_start);
            termIdElem === null || termIdElem === void 0 ? void 0 : termIdElem.setAttribute('value', data === null || data === void 0 ? void 0 : data.term_id);
            if (!success) {
                stopLoad = true;
                return;
            }
            if (data) {
                if (vtimelineWrapper && (data === null || data === void 0 ? void 0 : data.html)) {
                    const lastElement = vtimelineWrapper.querySelector('.js-last-element');
                    if ((statusElem === null || statusElem === void 0 ? void 0 : statusElem.getAttribute('value')) === '1') {
                        vtimelineWrapper.innerHTML = `${data === null || data === void 0 ? void 0 : data.html}<div class="js-last-element"></div>`;
                    }
                    else if (lastElement) {
                        if (loadMore) {
                            lastElement.insertAdjacentHTML('beforebegin', data === null || data === void 0 ? void 0 : data.html);
                        }
                        else {
                            vtimelineWrapper.innerHTML = `${data === null || data === void 0 ? void 0 : data.html}<div class="js-last-element"></div>`;
                        }
                        cardChange();
                        initCloseTimeline();
                    }
                }
            }
            else {
                stopLoad = true;
                statusElem === null || statusElem === void 0 ? void 0 : statusElem.setAttribute('value', '0');
            }
        }
        else {
            stopLoad = true;
            statusElem === null || statusElem === void 0 ? void 0 : statusElem.setAttribute('value', '0');
        }
    }
});
const onChangeFilter = (selectElement) => __awaiter(void 0, void 0, void 0, function* () {
    const formFieldsId = Array.from(selectElement.selectedOptions)
        .map((option) => option.value);
    if (selectElement instanceof HTMLSelectElement) {
        const id = selectElement.getAttribute('id');
        if (id && formFieldsId.includes(id)) {
            const pageCounter = document.getElementById('page_counter');
            if (pageCounter) {
                pageCounter.setAttribute('value', '0');
            }
        }
        statusElem === null || statusElem === void 0 ? void 0 : statusElem.setAttribute('value', '0');
        if (id === 'navigator_id') {
            const selectedOptions = Array.from(selectElement.selectedOptions).map(option => option.value);
            if (selectedOptions.length === 0) {
                dateStartElem === null || dateStartElem === void 0 ? void 0 : dateStartElem.setAttribute('value', '');
                termIdElem === null || termIdElem === void 0 ? void 0 : termIdElem.setAttribute('value', '');
                selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.setAttribute('value', '');
            }
            else {
                selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.setAttribute('value', selectedOptions[0]);
            }
        }
        stopLoad = false;
        const response = yield loadData(false);
    }
});
const mobileDropdown = () => {
    const btns = document.querySelectorAll('.js-open-filters');
    btns &&
        btns.forEach((item) => {
            item.addEventListener('click', (event) => {
                const target = event.target;
                if (target) {
                    const container = document.querySelector('.vtimeline');
                    if (!container)
                        return;
                    const filter = container.querySelector('#filtering_and_sorting');
                    if (!filter)
                        return;
                    filter.classList.toggle('active');
                }
            });
        });
};
const setEventListenerToNavigator = () => {
    const elements = document.querySelectorAll('.navigator-filter-block__item');
    if (elements instanceof NodeList) {
        elements.forEach((item) => {
            item.addEventListener('click', (event) => {
                if (item instanceof HTMLElement) {
                    item.classList.toggle('inactive');
                }
            });
        });
    }
};
const timeline = () => __awaiter(void 0, void 0, void 0, function* () {
    if (timelineLoadMoreButton && form) {
        timelineLoadMoreButton.addEventListener('click', (event) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield loadData(true);
        }));
    }
    setEventListenerToNavigator();
    mobileDropdown();
    cardChange();
    scrollContent();
    initCloseTimeline();
    window.addEventListener('scroll', () => __awaiter(void 0, void 0, void 0, function* () {
        var _e;
        const windowHeight = window.innerHeight;
        if (!timelineLoadMoreButton) {
            return;
        }
        if (!loadDataFlag && windowHeight > ((_e = timelineLoadMoreButton === null || timelineLoadMoreButton === void 0 ? void 0 : timelineLoadMoreButton.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.top)) {
            loadDataFlag = true;
            yield loadData(true);
            loadDataFlag = false;
        }
    }));
});
document.addEventListener('DOMContentLoaded', timeline, false);
